"use client"

export function Footer() {
  return (
    <footer className="border-t bg-background py-6">
      <div className="container mx-auto px-6 text-center text-sm text-muted-foreground">
        <p>Akiles © - Ecosystem / TheGame - All rights reserved - 2025</p>
      </div>
    </footer>
  )
} 